module.exports = __webpack_public_path__ + "img/VShow_Roxo.0b8955ad.png";